import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import './artist-details-block.css';
// import Facebook from '../../assets/images/social/black/facebook.png';
// import Instagram from '../../assets/images/social/black/instagram.png';
// import Spotify from '../../assets/images/social/black/spotify.png';


const ArtistDetailsBlock = ({artist}) => {
	const [authorized, setAuthorized] = useState(false);
	useEffect(() => {
			const auth = JSON.parse(localStorage.getItem('mb-auth'));
			if (auth) {
				setAuthorized(true);
			} else {
				setAuthorized(false);
			}
	}, []);

	return (
		<div>
		<div className='artist-details-container'>
			{ authorized ?
				<div>
					<Link className='artist-detail-nav-link' to={`/artist/${artist.id}`}>
						<img className='artist-details-icon' src={`https://media.tracktribe.com/images/artists/${artist.image}`} alt='' />
					</Link>
					
					<Link className='artist-detail-nav-link' to={`/artist/${artist.id}`}>
						<div className='artist-details-item'><b>{artist.artist_name}</b></div>
					</Link>
				</div>
			
				:
				
				<div>
						<img className='artist-details-icon' src={`https://media.tracktribe.com/images/artists/${artist.image}`} alt='' />
						<div className='artist-details-item'><b>{artist.artist_name}</b></div>
				</div>

			}

			

			{/* { (artist.artist_fb_url || artist.artist_ig_url) && (
				<div className='artist-details-social-block'>
					{artist.artist_fb_url && 
						<Link className='artist-detail-nav-link' to={artist.artist_fb_url}>
							<img className='social' src={Facebook} alt='' />
						</Link>
					} 

					{artist.artist_ig_url && 
						<Link className='artist-detail-nav-link' to={artist.artist_ig_url}>
							<img className='social' src={Instagram} alt='' />
						</Link>
					}
				</div>
			)} */}
		</div>

		
		</div>
  	)
}

export default ArtistDetailsBlock;